// Codex iter 2 NEW2 fix (Phase 3 M2): migrated from @mkkellogg/gaussian-splats-3d
// to three.js standard addons. mkkellogg dependency removal happens at M4.
import type * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

export interface OrbitConfig {
  target?: readonly [number, number, number];
  minDistance?: number;
  maxDistance?: number;
  enableDamping?: boolean;
  dampingFactor?: number;
}

export function createOrbitControls(
  camera: THREE.PerspectiveCamera,
  domElement: HTMLElement,
  config: OrbitConfig = {},
): OrbitControls {
  const controls = new OrbitControls(camera, domElement);
  controls.enableDamping = config.enableDamping ?? true;
  controls.dampingFactor = config.dampingFactor ?? 0.05;
  controls.minDistance = config.minDistance ?? 0.1;
  controls.maxDistance = config.maxDistance ?? 100;
  if (config.target !== undefined) {
    controls.target.set(config.target[0], config.target[1], config.target[2]);
  }
  controls.update();
  return controls;
}
